/*
 * 表格组件
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 15:16:59
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef, useState } from 'react';
import { Back_svg, Forward_svg } from 'image/index';
import Styles from './index.less';
var Table = function (_a) {
    var selectItem = _a.selectItem, dataSource = _a.dataSource, column = _a.column, onSelect = _a.onSelect;
    var tableArea = useRef(null);
    var _b = useState({
        total: 0,
        pageSize: 10,
        current: 1,
        pageNum: 1,
    }), pageData = _b[0], setPageData = _b[1];
    var _c = useState([]), display = _c[0], setDisplay = _c[1];
    useEffect(function () {
        var _a, _b, _c;
        var PageSize = ((_a = tableArea.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) === 0
            ? pageData.pageSize
            : Math.ceil((((_b = tableArea.current) === null || _b === void 0 ? void 0 : _b.offsetHeight)
                ? (_c = tableArea.current) === null || _c === void 0 ? void 0 : _c.offsetHeight
                : 0) / 41);
        setPageData(__assign(__assign({}, pageData), { total: dataSource === null || dataSource === void 0 ? void 0 : dataSource.length, pageSize: PageSize, pageNum: Math.ceil(((dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) ? dataSource === null || dataSource === void 0 ? void 0 : dataSource.length : 0) / PageSize) }));
        setDisplay(dataSource === null || dataSource === void 0 ? void 0 : dataSource.slice((pageData.current - 1) * PageSize, pageData.current * PageSize));
    }, [dataSource]);
    var getRadioStyle = function (id) {
        if (id === (selectItem === null || selectItem === void 0 ? void 0 : selectItem.id)) {
            return {
                inner: {
                    backgroundColor: '#5582F3',
                    width: 8,
                    height: 8,
                },
                outer: {
                    border: '1px solid #5582F3',
                },
            };
        }
    };
    var pageTurn = function (type) {
        if (type === 'back') {
            if (!(pageData.current - 1 <= 0)) {
                setPageData(__assign(__assign({}, pageData), { current: pageData.current - 1 }));
                setDisplay(dataSource === null || dataSource === void 0 ? void 0 : dataSource.slice((pageData.current - 2) * pageData.pageSize, (pageData.current - 1) * pageData.pageSize));
            }
        }
        else if (type === 'forward') {
            if (!(pageData.current + 1 > pageData.pageNum)) {
                setPageData(__assign(__assign({}, pageData), { current: pageData.current + 1 }));
                setDisplay(dataSource === null || dataSource === void 0 ? void 0 : dataSource.slice(pageData.current * pageData.pageSize, (pageData.current + 1) * pageData.pageSize));
            }
        }
    };
    var renderDisplay = function () {
        if (display) {
            return display.map(function (data) {
                var _a, _b;
                return (React.createElement("div", { key: "dataSource".concat(data === null || data === void 0 ? void 0 : data.id), onClick: function () { return onSelect(data); }, className: Styles.dataSourceItemWrapper },
                    React.createElement("div", { className: Styles.radioCol },
                        React.createElement("div", { style: (_a = getRadioStyle(data === null || data === void 0 ? void 0 : data.id)) === null || _a === void 0 ? void 0 : _a.outer, onClick: function () { return onSelect(data); }, className: Styles.selectRadioOuterRing },
                            React.createElement("div", { className: Styles.selectRadioInnerRing, style: (_b = getRadioStyle(data === null || data === void 0 ? void 0 : data.id)) === null || _b === void 0 ? void 0 : _b.inner }))),
                    column
                        .filter(function (columnItem) { return columnItem.isShow === true; })
                        .map(function (item) {
                        return (React.createElement("div", { key: item.key, style: __assign({}, item.style), className: Styles.tableItemBasic },
                            React.createElement("div", { className: Styles.tableItemBasicContent }, item.render(data))));
                    })));
            });
        }
        else {
            return null;
        }
    };
    var renderForze = function () {
        if (display) {
            return display.map(function (data) {
                return (React.createElement("div", { key: "dataSource".concat(data === null || data === void 0 ? void 0 : data.id), onClick: function () { return onSelect(data); }, className: Styles.dataSourceItemWrapper }, column
                    .filter(function (columnItem) { return columnItem.isShow === true; })
                    .map(function (item) {
                    return (React.createElement("div", { key: item.key, style: __assign({}, item.style), className: Styles.tableItemBasic },
                        React.createElement("div", { className: Styles.tableItemBasicContent }, item.render(data))));
                })));
            });
        }
        else {
            return null;
        }
    };
    return (React.createElement("div", { className: Styles.tableWrapper },
        React.createElement("div", { className: Styles.tableNav },
            React.createElement("span", null,
                "\u5171",
                pageData.total,
                "\u6761"),
            React.createElement("div", { className: Styles.PageTurningTool },
                React.createElement("div", { onClick: function () { return pageTurn('back'); }, className: Styles.PageBtn },
                    React.createElement("img", { alt: '', src: Back_svg })),
                React.createElement("div", { className: Styles.PageTurning }, pageData.current),
                React.createElement("div", { onClick: function () { return pageTurn('forward'); }, className: Styles.PageBtn },
                    React.createElement("img", { alt: '', src: Forward_svg })))),
        React.createElement("div", { className: Styles.tableBody },
            React.createElement("div", { className: Styles.tableScrollAreaHiddenY },
                React.createElement("div", { className: Styles.tableScrollArea },
                    React.createElement("div", { className: Styles.columns },
                        React.createElement("div", { className: Styles.radioCol },
                            React.createElement("div", { className: Styles.selectRadioOuterRing })),
                        column
                            .filter(function (columnItem) { return columnItem.isShow === true; })
                            .map(function (item) {
                            return (React.createElement("div", { key: item.key, style: __assign({}, item.style), className: Styles.tableItemTabs }, item.title));
                        })),
                    React.createElement("div", { ref: tableArea, className: Styles.tableDataArea }, renderDisplay()))))));
};
export default Table;
